import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RegistrationComponent} from "./registration/registration.component";
import {LoginComponent} from "./login/login.component";
import {SharedComponent} from "./shared/shared.component";
import {ForgotPasswordComponent} from "./forgot-password/forgot-password.component";
import {AuthGuard} from "./guards/auth.guard";
import {RememberMeGuard} from "./guards/remember-me.guard";
import {AddQuizComponent} from "./quiz/add-quiz/add-quiz.component";
import {TestConfigurationComponent} from "./quiz/test-configuration/test-configuration.component";
import {QuestionManagerComponent} from "./quiz/question-manager/question-manager.component";
import {AddQuizGuard} from "./guards/add-quiz.guard";
import {OtherSettingsComponent} from "./quiz/other-settings/other-settings.component";
import {ResultsTableComponent} from "./quiz/results-table/results-table.component";
import {StartPageComponent} from "./quiz/start-page/start-page.component";
import {ExamComponent} from "./exam/exam.component";
import {RespondentResultComponent} from "./quiz/respondent-result/respondent-result.component";
import {
  QuizRespondentValidationComponent
} from "./quiz/quiz-respondent-validation/quiz-respondent-validation.component";
import {ResultsDatabaseComponent} from "./results-database/results-database.component";
import {RespondentMonitoringComponent} from "./quiz/respondent-monitoring/respondent-monitoring.component";
import {LandingComponent} from "./landing/landing.component";
import {MainLayoutComponent} from "./main-layout/main-layout.component";
import {
  ResultsDatabaseFilterComponent
} from "./results-database/results-database-filter/results-database-filter.component";
import {ProfileSettingsComponent} from "./profile-settings/profile-settings.component";
import {
  ProfilePersonalInformationComponent
} from "./profile-settings/pages/profile-personal-information/profile-personal-information.component";
import {
  ProfilePaymentMethodComponent
} from "./profile-settings/pages/profile-payment-method/profile-payment-method.component";
import {
  ProfileSubscriptionHistoryComponent
} from "./profile-settings/pages/profile-subscription-history/profile-subscription-history.component";
import {ProfileMyPlanComponent} from "./profile-settings/pages/profile-my-plan/profile-my-plan.component";
import {SubscriptionsComponent} from "./subscriptions/subscriptions.component";
import {ManageSubscriptionComponent} from "./subscriptions/manage-subscription/manage-subscription.component";
import {ContactUsComponent} from "./contact-us/contact-us.component";

export const routes: Routes = [
  {path: 'signin', component: LoginComponent, canActivate: [RememberMeGuard]},
  {path: 'signup', component: RegistrationComponent},
  {path: 'forgot/password', component: ForgotPasswordComponent, pathMatch: 'full'},
  {path: 'contact-us', component: ContactUsComponent},
  {path: '', component: LandingComponent},
  {path: 'quiz-respondent', component: QuizRespondentValidationComponent, pathMatch: 'full'},
  {path: 'start/quiz', component: StartPageComponent},
  {path: 'exam', component: ExamComponent},
  {path: 'results/test-result/:quizId/:respondentId', component: RespondentResultComponent},

  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {path: 'dashboard', component: SharedComponent, data: {title: 'My Tests'}},
      {path: 'results-database', component: ResultsDatabaseComponent, data: {title: 'Results Database'}},
      {path: 'results-database-filter', component: ResultsDatabaseFilterComponent, data: {title: 'filter'}},
      {
        path: 'quiz',
        component: TestConfigurationComponent,
        children: [
          {path: 'add', component: AddQuizComponent, canActivate: [AddQuizGuard], pathMatch: 'full'},
          {path: 'question/manager', component: QuestionManagerComponent, pathMatch: 'full'},
          {path: 'other/settings', component: OtherSettingsComponent, pathMatch: 'full'},
          {path: 'results/table', component: ResultsTableComponent, pathMatch: 'full'},
          {path: 'respondent/monitoring', component: RespondentMonitoringComponent, pathMatch: 'full'},
        ]
      },
      {
        path: 'profile-settings', component: ProfileSettingsComponent, children: [
          {path: 'personal-information', component: ProfilePersonalInformationComponent},
          {path: 'payment-method', component: ProfilePaymentMethodComponent},
          {path: 'subscription-history', component: ProfileSubscriptionHistoryComponent},
          {path: 'my-plan', component: ProfileMyPlanComponent},
        ]
      },
      {path: 'subscriptions', component: SubscriptionsComponent},
      {path: 'subscriptions/manage', component: ManageSubscriptionComponent},
      {path: 'subscriptions/manage/:id', component: ManageSubscriptionComponent},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
